import _ from 'lodash';

window._ = _;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

// import axios from 'axios';
// window.axios = axios;
//
// window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
// window.axios.defaults.withCredentials = true;

import '../../vendor/wire-elements/pro/resources/js/overlay-component.js';
import '../../vendor/wire-elements/pro/resources/js/spotlight-component.js';
import './echo';

/**
 * The Clipboard API only exists in secure contexts (https / localhost), but
 * Filament's copyable columns call navigator.clipboard.writeText() directly —
 * on http://app.approvethis.test that throws "Cannot read properties of
 * undefined (reading 'writeText')". Back-fill it with the legacy execCommand
 * approach so click-to-copy works in local dev too.
 */
if (!window.navigator.clipboard) {
    Object.defineProperty(window.navigator, 'clipboard', {
        value: {
            writeText: (text) =>
                new Promise((resolve, reject) => {
                    const textarea = document.createElement('textarea');
                    textarea.value = text;
                    textarea.style.position = 'fixed';
                    textarea.style.opacity = '0';
                    document.body.appendChild(textarea);
                    textarea.focus();
                    textarea.select();
                    try {
                        document.execCommand('copy')
                            ? resolve()
                            : reject(new Error('execCommand("copy") failed'));
                    } finally {
                        textarea.remove();
                    }
                }),
        },
    });
}
